import React from "react"
import cx from "classnames"

export type ModalFooterPropsType = {
  children?: React.ReactNode
  className?: string
}

const ModalFooter = ({ children, className }: ModalFooterPropsType) => {
  return <div className={cx("cobalt-modal-footer", className)}>{children}</div>
}

export default ModalFooter
